module.exports = __webpack_public_path__ + "media/1x1/mz-e99caf39.svg";